var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialTwiter = function SvgD28SocialTwiter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-28-social-twiter_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.152941 0 0 0 0 0.149020 0 0 0 0 0.164706 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-28-social-twiter_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.02 8.593a6.368 6.368 0 0 1-.813.296c.328-.372.578-.808.73-1.286a.27.27 0 0 0-.395-.316c-.59.35-1.224.6-1.89.747a3.624 3.624 0 0 0-2.525-1.029 3.61 3.61 0 0 0-3.577 4.073 9.233 9.233 0 0 1-6.337-3.362.27.27 0 0 0-.444.034 3.605 3.605 0 0 0-.489 1.814c0 .869.31 1.693.859 2.337a3.055 3.055 0 0 1-.483-.215.27.27 0 0 0-.403.23v.049a3.62 3.62 0 0 0 1.765 3.101 3.11 3.11 0 0 1-.274-.04.27.27 0 0 0-.309.35 3.605 3.605 0 0 0 2.642 2.417 6.38 6.38 0 0 1-3.41.973c-.256 0-.513-.015-.764-.045a.271.271 0 0 0-.178.497 9.726 9.726 0 0 0 5.259 1.542c3.672 0 5.969-1.732 7.25-3.184 1.596-1.811 2.511-4.209 2.511-6.577 0-.1-.001-.2-.004-.299a7.011 7.011 0 0 0 1.613-1.709.27.27 0 0 0-.335-.398z",
    fill: "#000",
    fillRule: "nonzero"
  })))));
};
export default SvgD28SocialTwiter;